import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts"
import { Box, Typography, useTheme } from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

interface HourlyBarChartProps {
  stats: ChatAnalyze.Stats
}

export function HourlyBarChart({ stats }: HourlyBarChartProps) {
  const theme = useTheme()

  const data = Array.from({ length: 24 }, (_, h) => ({
    hour: `${String(h).padStart(2, "0")}`,
    count: stats.hourMsgs[String(h)] ?? 0,
  }))

  const maxCount = Math.max(...data.map((d) => d.count), 1)

  return (
    <Box>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart
          data={data}
          margin={{ top: 4, right: 4, left: -20, bottom: 0 }}
        >
          <XAxis
            dataKey="hour"
            tick={{ fontSize: 10, fill: theme.palette.text.secondary }}
            interval={2}
          />
          <YAxis
            tick={{ fontSize: 10, fill: theme.palette.text.secondary }}
            width={35}
          />
          <Tooltip
            formatter={(value: number | undefined) => [
              (value ?? 0).toLocaleString("ru-RU"),
              "Сообщений",
            ]}
            labelFormatter={(label) => `${label}:00 — ${label}:59`}
            labelStyle={{ color: theme.palette.text.secondary }}
            itemStyle={{ color: theme.palette.text.primary }}
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 4,
              fontSize: 12,
              color: theme.palette.text.primary,
            }}
          />
          <Bar dataKey="count" radius={[2, 2, 0, 0]}>
            {data.map((entry) => (
              <Cell
                key={entry.hour}
                fill={
                  entry.count === maxCount
                    ? theme.palette.secondary.main
                    : theme.palette.info.main
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 1, display: "block" }}
      >
        Выделен пик активности. Ночная активность (00–07):{" "}
        <strong>{stats.nightShare.toFixed(1)}%</strong>
        {stats.nightShare < 15
          ? " — норма ✅"
          : stats.nightShare < 25
            ? " — повышено ⚡"
            : " — подозрительно ⚠️"}
      </Typography>
    </Box>
  )
}
